export default __webpack_public_path__ + "locales/tr/Settings.json?hash=f5577525762c307af2c927f1980dd544";